export enum Intl {
    da_DK = "da_DK",
    en_US = "en_US",
    de_DE = "de_DE",
}
